import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { TableContent } from 'src/app/construct-x/shared/common/interfaces';
import { CommonModule } from '@angular/common';
import { NgComponentOutlet } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-expandable-table',
  templateUrl: './expandable-table.component.html',
  styleUrls: ['./expandable-table.component.scss'],
  imports: [CommonModule, NgComponentOutlet, MatTableModule, MatTooltipModule],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ExpandableTableComponent implements OnInit, OnChanges {

  @Input() dataSource: TableContent[] = [];
  @Input() sortMethods: { [key: string]: { asc: (property: string) => TableContent[], desc: (property: string) => TableContent[] }} = {};

  initialDataSource: TableContent[] = [];
  columnsToDisplay: string[] = [];
  expandedRowIndex: number | null = null;

  sortIcons = { default: "swap_vert", asc: "arrow_upward", desc: "arrow_downward" };
  sortProperty: { [key: string]: string } = {};


  constructor() { }

  ngOnInit(): void { this.initial(); }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['dataSource']) this.initial();
  }

  initial() {
    if(this.dataSource.length === 0) return;
    if(this.initialDataSource.length === 0) this.initialDataSource = [...this.dataSource];
    this.columnsToDisplay = [...Object.keys(this.dataSource[0]).filter(key => key !== 'expandDetails'), 'expand'];
    Object.keys(this.sortMethods).forEach(key => {
      if(!(key in this.sortProperty)) this.sortProperty[key] = this.sortIcons.default;
    });
    if(this.expandedRowIndex !== null && this.expandedRowIndex >= this.dataSource.length) this.expandedRowIndex = null;
  }

  sortData(property: string): void {
    if(this.sortProperty[property] === this.sortIcons.default) {
      this.sortProperty[property] = this.sortIcons.asc;
      this.sortMethods[property].asc(property);
    } else if(this.sortProperty[property] === this.sortIcons.asc) {
      this.sortProperty[property] = this.sortIcons.desc;
      this.sortMethods[property].desc(property);
    } else {
      this.sortProperty[property] = this.sortIcons.default;
      this.dataSource = this.initialDataSource;
    }
  }

  elemClicked(clickAction: () => void | undefined) {
    if(clickAction) clickAction();
  }

}